import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';

const RATING_LABELS = {
  5: 'Obsessed. Need it again.',
  4: 'Big fan energy.',
  3: 'Cute, but not life-changing.',
  2: 'Not the vibe.',
  1: 'Regret in a cup.',
};

export default function StarRating({ rating = 0, max = 5, size = 16, interactive = false, onChange, showLabel = false }) {
  const stars = (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: max }).map((_, i) => {
        const filled = i < Math.round(rating);
        return (
          <button
            key={i}
            type={interactive ? 'button' : undefined}
            disabled={!interactive}
            onClick={interactive ? () => onChange?.(i + 1) : undefined}
            className={cn(
              'transition-transform duration-100',
              interactive && 'hover:scale-125 cursor-pointer',
              !interactive && 'cursor-default'
            )}
          >
            <Star
              size={size}
              className={cn(filled ? 'star-filled fill-current' : 'star-empty')}
              strokeWidth={1.5}
            />
          </button>
        );
      })}
    </div>
  );

  if (!showLabel) return stars;

  return (
    <div className="space-y-1.5">
      {stars}
      <p className="text-sm font-semibold text-foreground min-h-[1.25rem]">
        {RATING_LABELS[Math.round(rating)] ?? ''}
      </p>
    </div>
  );
}